import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { Review } from 'src/app/core/model/v2/review/review';
import { ReviewDetail } from 'src/app/core/model/v2/review/review-detail';

@Component({
  selector: 'app-physician-review-details',
  templateUrl: './physician-review-details.component.html',
  styleUrls: ['./physician-review-details.component.scss']
})
export class PhysicianReviewDetailsComponent implements OnInit {

  reviews: Review[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ReviewDetail
  ) { }

  ngOnInit() {
    this.reviews = this.data.reviews;
  }

  changeFilter(selected: number): void {
    this.reviews = this.data.reviews.filter(x => x.rating == selected);
    if(selected == 0){
      this.reviews = this.data.reviews;
    }
  }

}
